import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from '@adsk/bim360-matrix-react-button';
import './_AnchorButton.scss';

/**
 * An button component which looks like an html anchor
 */
const AnchorButton = props => {
  const { children, hovered, className, ...restProps } = props;
  const cx = classnames('AnchorButton', className, {
    'AnchorButton--hover': hovered
  });
  return (
    <Button {...restProps} styleType={Button.StyleType.INLINE_LINK} className={cx}>
      {children}
    </Button>
  );
};

AnchorButton.propTypes = {
  /**
   * A callback function for click event
   */
  onClick: PropTypes.func,
  /**
   * A custom className
   */
  className: PropTypes.string,
  /**
   * Whether the button is in hover state
   */
  hovered: PropTypes.bool,
  /**
   * The components's children
   */
  children: PropTypes.node.isRequired
};

export default AnchorButton;
